<template xmlns="http://www.w3.org/1999/html">
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="header-title title-section form-section">
            <h5 class="page-title-home-inspector text-center">Quick Application! <br />
              Get Pricing in Less than 5 Minutes</h5>
            <p v-if="getApplicantType === 'RWS'" class="page-desc text-center"
            >Home Inspector Professional Liability Errors & Omissions (E&O) & General Liability Coverage Insurance Application</p>
            <p v-else-if="getApplicantType === 'RISKPRO'" class="page-desc text-center"
            >Home Inspector Professional Liability Errors & Omissions (E&O) & General Liability Coverage Insurance Application</p>
            <p v-else class="page-desc text-center"
            >OREP Home Inspector Professional Liability Errors & Omissions (E&O) & General Liability Coverage Insurance Application</p>
            <img
              src="../../../public/assets/images/calc.png"
              class="title-section-img"
              alt="background image"
            >
          </article>
          <article class="more-desc form-section">
            <p
            ><b>CLAIMS-MADE WARNING FOR APPLICATION:</b> NOTICE: THIS APPLICATION IS FOR A CLAIMS-MADE AND REPORTED IN WRITING POLICY. SUBJECT TO ITS TERMS, THIS POLICY WILL APPLY ONLY TO CLAIMS FIRST MADE AGAINST THE INSUREDS DURING THE POLICY PERIOD AND FIRST REPORTED TO THE INSURER DURING THE POLICY PERIOD OR ANY EXTENDED REPORTING PERIOD THAT MAY APPLY. THIS POLICY CONTAINS PROVISIONS THAT LIMIT THE AMOUNT OF CLAIM EXPENSES THE INSURER IS RESPONSIBLE TO PAY IN CONNECTION WITH CLAIMS, AND THE PAYMENT OF CLAIM EXPENSES WILL REDUCE THE LIMITS OF LIABILITY AVAILABLE TO DAMAGES. PLEASE READ THE POLICY CAREFULLY TO DETERMINE RIGHTS, DUTIES, COVERAGE & COVERAGE RESTRICTIONS.</p>
            <p class="more-desc-p flex">
              <i class="legalese-fa fas fa-info-circle"></i>
              <span>Whenever used in this Application, the term “Applicant” shall mean the proposed Named Insured, unless otherwise stated.</span>
            </p>
          </article>
<!--          <article class="premiums form-section">-->
<!--            <h2 class="premiums-h2 mb-4 px-5">OREP Program Minimum Premiums E&O/GL</h2>-->
<!--&lt;!&ndash;            <h2 class="premiums-h2">$1,500 Deductible</h2>&ndash;&gt;-->
<!--            <div class="table-responsive hc-table">-->
<!--              <table class="table">-->
<!--                <thead>-->
<!--                  <tr>-->
<!--                    <th>State</th>-->
<!--                    <th>$100,000/$300,000 Limit</th>-->
<!--                    <th>$500,000/$500,000 Limit</th>-->
<!--                    <th>$1 Million / $1 Million Limit</th>-->
<!--                  </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                  <tr>-->
<!--                    <td>TX</td>-->
<!--                    <td>$850</td>-->
<!--                    <td>$1,200</td>-->
<!--                    <td>$1,350</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>ca, fl, nj, ny</td>-->
<!--                    <td>$1,200</td>-->
<!--                    <td>$1,400</td>-->
<!--                    <td>$1,550</td>-->
<!--                  </tr>-->
<!--                  <tr>-->
<!--                    <td>All Other states</td>-->
<!--                    <td>$975</td>-->
<!--                    <td>$1,300</td>-->
<!--                    <td>$1,450</td>-->
<!--                  </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--            </div>-->
<!--            <p class="more-desc premiums-desc flex">-->
<!--              <i class="premiums-fa legalese-fa fas fa-info-circle"></i>-->
<!--              <span>-->
<!--                Minimum premiums noted above include a $1,500 Retention and are conditional on claims history,-->
<!--                revenues, experience inspecting and other underwriting factors. State surplus lines taxes-->
<!--                and fees additional where applicable. Coverage package includes E&O & General Liability/Coverage plus coverage for-->
<!--                all these additional services FREE (see question 34). Additional limits and Retentions available.-->
<!--              </span>-->
<!--            </p>-->
<!--          </article>-->
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Personal</h1>
              <img
                src="../../../public/assets/images/glasses.png"
                class="title-section-img form-title-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">1.</span>Full legal name of Applicant / Business Name (including any aliases):
              </label>
              <input
                type="text"
                name="fullLegalNameOfApplicant"
                v-model="quote.fullLegalNameOfApplicant"
                class="orep-text-input"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('fullLegalNameOfApplicant')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('fullLegalNameOfApplicant') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5"></span>Name of Principal / Primary Home Inspector:
              </label>
              <input
                type="text"
                name="nameOfPrincipalHomeInspector"
                v-model="quote.nameOfPrincipalHomeInspector"
                class="orep-text-input"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('nameOfPrincipalHomeInspector')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('nameOfPrincipalHomeInspector') | filterText }}</span>
            </article>
            <article class="form-section">
              <div class="input-section">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">2.</span>Address of Applicant (Please list additional locations on a separate page):
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="quote.customer.address"
                  class="orep-text-input"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
              <div class="pt-0 input-section">
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>City:
                    </label>
                    <input
                      type="text"
                      name="city"
                      v-model="quote.customer.city"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('city')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('city') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>State:
                    </label>
                    <select
                      class="orep-select w-100"
                      style="height: 40px;"
                      name="state"
                      v-model="quote.customer.state"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                    <span
                      v-show="errors.has('state')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('state') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Zip Code:
                    </label>
                    <input
                      type="text"
                      name="zipCode"
                      v-model="quote.customer.zipCode"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('zipCode')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('zipCode') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Telephone
                    </label>
                    <input
                      type="text"
                      name="phone"
                      v-model="quote.customer.phone"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('phone')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('phone') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Website:
                    </label>
                    <input
                      type="text"
                      name="website"
                      v-model="quote.website"
                      class="orep-text-input w-100"
                    >
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Email:
                    </label>
                    <input
                      type="email"
                      name="email"
                      autocomplete="email"
                      v-model="quote.customer.email"
                      class="orep-text-input w-100"
                      v-validate="'required|email'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('email')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('email') | filterText }}</span>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row pb-3">
                <div class="col-md-4">
                  <label for class="orep-label mb-0">
                    <span class="qtn mrpx-5"></span>Year Business Established:
                  </label>
                  <!--                    <input-->
                  <!--                      type="text"-->
                  <!--                      name="yearOfBusinessEstablishment"-->
                  <!--                      v-model="quote.yearOfBusinessEstablishment"-->
                  <!--                      class="orep-text-input w-100"-->
                  <!--                      v-validate="'required|numeric'"-->
                  <!--                      @input="validateBeforeSubmit()"-->
                  <!--                    >-->
                  <select
                    class="orep-select w-100"
                    style="height: 40px; width: 383px;"
                    name="year"
                    v-model="quote.yearOfBusinessEstablishment"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                  >
                    <option v-for="(item, key) in years" :value="item">
                      {{item}}
                    </option>
                  </select>
                  <span
                    v-show="errors.has('year')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('year') | filterText }}</span>
                </div>
              </div>
        </article>
            <article class="input-section form-section">
              <div class="form-group row">
                <div class="col-md-9">
                  <label for class="orep-label mb-0">
                    <span class="qtn mrpx-5">3.</span>Is the Applicant a franchisee?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isFranchisee"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.isFranchisee"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isFranchisee"
                          value="false"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.isFranchisee"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('isFranchisee')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('isFranchisee') | filterText }}</span>
                </div>
              </div>
              <input
                type="text"
                class="orep-text-input js-orep-input"
                placeholder="Please provide the full legal name of the franchisor"
                v-if="quote.isFranchisee === 'true' || quote.isFranchisee == true"
                name="fullLegalNameOfFranchisor"
                v-model="quote.fullLegalNameOfFranchisor"
              >
            </article>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Principal's/Applicant's
                <br>Experience and Training
              </h1>
              <img
                src="../../../public/assets/images/house.png"
                class="title-section-img form-title-img exp-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">4 a.</span>Home Inspecting Experience:
              </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="homeInspectingExperience"
                    value="less-3"
                    class="orep-radio"
                    v-validate="'required|included:less-3,3-to-7,more-than-7'"
                    @change="validateBeforeSubmit()"
                    v-model="quote.homeInspectingExperience"
                  >
                  <span class="radio-span">Less than 3 Years</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="homeInspectingExperience"
                    value="3-to-7"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.homeInspectingExperience"
                  >
                  <span class="radio-span">3-7 years</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="homeInspectingExperience"
                    value="more-than-7"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.homeInspectingExperience"
                  >
                  <span class="radio-span">7+ years</span>
                </label>
              </div>
              <span
                v-show="errors.has('homeInspectingExperience')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('homeInspectingExperience') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">b.</span>Related Industry Experience:
              </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="relatedIndustryExperience"
                    value="less-3"
                    class="orep-radio"
                    v-validate="'required|included:less-3,3-to-7,more-than-7'"
                    @change="validateBeforeSubmit()"
                    v-model="quote.relatedIndustryExperience"
                  >
                  <span class="radio-span">Less than 3 years</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="relatedIndustryExperience"
                    value="3-to-7"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.relatedIndustryExperience"
                  >
                  <span class="radio-span">3-7 years</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="relatedIndustryExperience"
                    value="more-than-7"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.relatedIndustryExperience"
                  >
                  <span class="radio-span">7+ years</span>
                </label>
              </div>
              <p class="form-p">
                Related industry experience includes experience in construction and building related professions,
                such as builders, contractors, general contractors, construction project managers, plumbers, carpenters,
                or electricians and/or Certificates of home inspector training from a recognized training program.
              </p>
              <span
                v-show="errors.has('relatedIndustryExperience')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('relatedIndustryExperience') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">5 a.</span>Is Applicant Licensed by all States in which they do business (If You Are in the Process of Getting Licensed, Please Answer Yes)?:
              </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="licensedInWorkingStates"
                    value="yes"
                    class="orep-radio"
                    v-validate="'required|included:yes,no,not-required'"
                    @change="validateBeforeSubmit()"
                    v-model="quote.licensedInWorkingStates"
                  >
                  <span class="radio-span">Yes</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="licensedInWorkingStates"
                    value="no"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.licensedInWorkingStates"
                  >
                  <span class="radio-span">No</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="licensedInWorkingStates"
                    value="not-required"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.licensedInWorkingStates"
                  >
                  <span class="radio-span">Not Required</span>
                </label>
              </div>

              <span
                v-show="errors.has('licensedInWorkingStates')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('licensedInWorkingStates') | filterText }}</span>
            </article>

            <article class="input-section form-section"
                     v-show="quote.licensedInWorkingStates === 'no'">
              <label for class="orep-label">
                <span class="qtn mrpx-5">5 b.</span>Have you completed all the requirements for licensing in the state(s) in which you do business with the exception of the insurance being applied for here?
              </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="requirementsLicensedInWorkingStates"
                    value="yes"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.requirementsLicensedInWorkingStates"
                  >
                  <span class="radio-span">Yes</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="requirementsLicensedInWorkingStates"
                    value="no"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.requirementsLicensedInWorkingStates"
                  >
                  <span class="radio-span">No</span>
                </label>
              </div>
              <p class="form-p">
                If you are in a state that requires licensing, you must complete the licensing process for this policy to respond. After binding insurance, please submit proof of licensing once completed.
              </p>
              <span
                v-show="errors.has('requirementsLicensedInWorkingStates')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('requirementsLicensedInWorkingStates') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">5 c.</span>Please list home inspector training school (s) applicant has attended (if any):
              </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    id="ati"
                    name="applicantTraining"
                    value="ati"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.applicantTraining"
                  >
                  <span class="radio-span">ATI Training School (ATI)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    id="ahit"
                    name="applicantTraining"
                    value="ahit"
                    @change="validateBeforeSubmit()"
                    class="orep-radio"
                    v-model="quote.applicantTraining"
                  >
                  <span
                    class="radio-span"
                  >American Home Inspector Training (AHIT)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    id="icaschool"
                    name="applicantTraining"
                    value="icaschool"
                    @change="validateBeforeSubmit()"
                    class="orep-radio"
                    v-model="quote.applicantTraining"
                  >
                  <span class="radio-span">Inspection Certification Associates (ICA School)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    id="internachi"
                    name="applicantTraining"
                    value="internachi"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.applicantTraining"
                  >
                  <span class="radio-span">InterNACHI</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    id="other"
                    name="applicantTraining"
                    value="other"
                    class="orep-radio"
                    @change="validateBeforeSubmit()"
                    v-model="quote.applicantTraining"
                  >
                  <span class="radio-span">Other</span>
                </label>
              </div>

              <input
                v-if="quote.applicantTraining === 'other'"
                type="text"
                name="applicantTrainingOtherDetails"
                class="orep-text-input"
                v-model="quote.applicantTrainingOtherDetails"
                placeholder="Other (please list)"
              >
              <span
                v-show="errors.has('applicantTraining')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('applicantTraining') | filterText }}</span>
            </article>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Financial</h1>
              <img
                src="../../../public/assets/images/financial.png"
                class="title-section-img form-title-img financial-section-img"
                alt="background image"
              >
            </article>
            <article class="form-section">
              <h4 class="inputs-table-title text-center">
                <span class="qtn mrpx-5">6.</span>Revenue/Number of Inspections:
              </h4>
              <div class="table-responsive hc-table inputs-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th colspan="3" class="right-border">
                        Previous Complete
                        Calendar Year
                      </th>
                      <th colspan="3">
                        Estimate Next 12 Months
                        (New inspectors, please estimate.)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="title-row">
                      <td></td>
                      <td>revenue</td>
                      <td class="right-border">Total Number of Inspections</td>
                      <td></td>
                      <td>revenue</td>
                      <td>Total Number of Inspections</td>
                    </tr>
                    <tr>
                      <td class="td-res">Residential 1-4 units</td>
                      <td>
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="revenueFromResidentialInspectionsInThisYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="revenueFromResidentialInspectionsInThisYear"
                        >
                        <span
                          v-show="errors.has('revenueFromResidentialInspectionsInThisYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('revenueFromResidentialInspectionsInThisYear') | filterText }}</span>
                      </td>
                      <td class="right-border">
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="numberOfResidentialInspectionsInThisYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="numberOfResidentialInspectionsInThisYear"
                        >
                        <span
                          v-show="errors.has('numberOfResidentialInspectionsInThisYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('numberOfResidentialInspectionsInThisYear') | filterText }}</span>
                      </td>
                      <td></td>
                      <td>
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="revenueFromResidentialInspectionsExpectedInNextYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="revenueFromResidentialInspectionsExpectedInNextYear"
                        >
                        <span
                          v-show="errors.has('revenueFromResidentialInspectionsExpectedInNextYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('revenueFromResidentialInspectionsExpectedInNextYear') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="numberOfResidentialInspectionsExpectedInNextYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="numberOfResidentialInspectionsExpectedInNextYear"
                        >
                        <span
                          v-show="errors.has('numberOfResidentialInspectionsExpectedInNextYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('numberOfResidentialInspectionsExpectedInNextYear') | filterText }}</span>
                      </td>
                    </tr>
<!--                    <tr>-->
<!--                      <td class="td-res">Residential over 4 units</td>-->
<!--                      <td>-->
<!--                        <i class="fas fa-dollar-sign"></i>-->
<!--                        <input-->
<!--                          type="text"-->
<!--                          class="orep-text-input js-orep-input table-text-input"-->
<!--                          name="revenueFromResidentialOverInspectionsInThisYear"-->
<!--                          v-validate="'numeric'"-->
<!--                          placeholder="0"-->
<!--                          @input="validateBeforeSubmit()"-->
<!--                          v-model="revenueFromResidentialOverInspectionsInThisYear"-->
<!--                        >-->
<!--                        <span-->
<!--                          v-show="errors.has('revenueFromResidentialOverInspectionsInThisYear')"-->
<!--                          class="help is-danger form-errors text-danger"-->
<!--                        >{{ errors.first('revenueFromResidentialOverInspectionsInThisYear') | filterText }}</span>-->
<!--                      </td>-->
<!--                      <td class="right-border">-->
<!--                        <input-->
<!--                          type="text"-->
<!--                          class="orep-text-input js-orep-input table-text-input"-->
<!--                          name="numberOfResidentialOverInspectionsInThisYear"-->
<!--                          placeholder="0"-->
<!--                          v-validate="'numeric'"-->
<!--                          @input="validateBeforeSubmit()"-->
<!--                          v-model="numberOfResidentialOverInspectionsInThisYear"-->
<!--                        >-->
<!--                        <span-->
<!--                          v-show="errors.has('numberOfResidentialOverInspectionsInThisYear')"-->
<!--                          class="help is-danger form-errors text-danger"-->
<!--                        >{{ errors.first('numberOfResidentialOverInspectionsInThisYear') | filterText }}</span>-->
<!--                      </td>-->
<!--                      <td></td>-->
<!--                      <td>-->
<!--                        <i class="fas fa-dollar-sign"></i>-->
<!--                        <input-->
<!--                          type="text"-->
<!--                          class="orep-text-input js-orep-input table-text-input"-->
<!--                          name="revenueFromResidentialOverInspectionsExpectedInNextYear"-->
<!--                          v-validate="'numeric'"-->
<!--                          placeholder="0"-->
<!--                          @input="validateBeforeSubmit()"-->
<!--                          v-model="revenueFromResidentialOverInspectionsExpectedInNextYear"-->
<!--                        >-->
<!--                        <span-->
<!--                          v-show="errors.has('revenueFromResidentialOverInspectionsExpectedInNextYear')"-->
<!--                          class="help is-danger form-errors text-danger"-->
<!--                        >{{ errors.first('revenueFromResidentialOverInspectionsExpectedInNextYear') | filterText }}</span>-->
<!--                      </td>-->
<!--                      <td>-->
<!--                        <input-->
<!--                          type="text"-->
<!--                          class="orep-text-input js-orep-input table-text-input"-->
<!--                          name="numberOfResidentialOverInspectionsExpectedInNextYear"-->
<!--                          v-validate="'numeric'"-->
<!--                          placeholder="0"-->
<!--                          @input="validateBeforeSubmit()"-->
<!--                          v-model="numberOfResidentialOverInspectionsExpectedInNextYear"-->
<!--                        >-->
<!--                        <span-->
<!--                          v-show="errors.has('numberOfResidentialOverInspectionsExpectedInNextYear')"-->
<!--                          class="help is-danger form-errors text-danger"-->
<!--                        >{{ errors.first('numberOfResidentialOverInspectionsExpectedInNextYear') | filterText }}</span>-->
<!--                      </td>-->
<!--                    </tr>-->
                    <tr>
                      <td class="td-res">
                        <i class="fa-com fas fa-info-circle"></i>Commercial
                      </td>
                      <td>
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="revenueFromCommercialInspectionsInThisYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="revenueFromCommercialInspectionsInThisYear"
                        >
                        <span
                          v-show="errors.has('revenueFromCommercialInspectionsInThisYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('revenueFromCommercialInspectionsInThisYear') | filterText }}</span>
                      </td>
                      <td class="right-border">
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="numberOfCommercialInspectionsInThisYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="numberOfCommercialInspectionsInThisYear"
                        >
                        <span
                          v-show="errors.has('numberOfCommercialInspectionsInThisYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('numberOfCommercialInspectionsInThisYear') | filterText }}</span>
                      </td>
                      <td></td>
                      <td>
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="revenueFromCommercialInspectionsExpectedInNextYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="revenueFromCommercialInspectionsExpectedInNextYear"
                        >
                        <span
                          v-show="errors.has('revenueFromCommercialInspectionsExpectedInNextYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('revenueFromCommercialInspectionsExpectedInNextYear') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="numberOfCommercialInspectionsExpectedInNextYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="numberOfCommercialInspectionsExpectedInNextYear"
                        >
                        <span
                          v-show="errors.has('numberOfCommercialInspectionsExpectedInNextYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('numberOfCommercialInspectionsExpectedInNextYear') | filterText }}</span>
                      </td>
                    </tr>
                    <tr class="tr-border">
                      <td class="td-res">Other (please explain)</td>
                      <td>
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="revenueFromOtherInspectionsInThisYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="revenueFromOtherInspectionsInThisYear"
                        >
                        <span
                          v-show="errors.has('revenueFromOtherInspectionsInThisYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('revenueFromOtherInspectionsInThisYear') | filterText }}</span>
                      </td>
                      <td class="right-border">
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="numberOfOtherInspectionsInThisYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="numberOfOtherInspectionsInThisYear"
                        >
                        <span
                          v-show="errors.has('numberOfOtherInspectionsInThisYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('numberOfOtherInspectionsInThisYear') | filterText }}</span>
                      </td>
                      <td></td>
                      <td>
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="revenueFromOtherInspectionsExpectedInNextYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="revenueFromOtherInspectionsExpectedInNextYear"
                        >
                        <span
                          v-show="errors.has('revenueFromOtherInspectionsExpectedInNextYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('revenueFromOtherInspectionsExpectedInNextYear') | filterText }}</span>
                      </td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="numberOfOtherInspectionsExpectedInNextYear"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="numberOfOtherInspectionsExpectedInNextYear"
                        >
                        <span
                          v-show="errors.has('numberOfOtherInspectionsExpectedInNextYear')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('numberOfOtherInspectionsExpectedInNextYear') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="td-res pt-35">Total</td>
                      <td class="pt-35">
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          disabled
                          v-model="$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear']"
                        >
                      </td>
                      <td class="pt-35 right-border">
                        <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          disabled
                          v-model="$store.getters['homeInspector/totalNumberOfInspectionsInThisYear']"
                        >
                      </td>
                      <td></td>
                      <td class="pt-35">
                        <i class="fas fa-dollar-sign"></i>
                        <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          v-model="$store.getters['homeInspector/totalRevenueOfInspectionsInNextYear']"
                          disabled
                        >
                      </td>
                      <td class="pt-35">
                        <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          v-model="$store.getters['homeInspector/totalNumberOfInspectionsInNextYear']"
                          disabled
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p class="more-desc-p table-p flex">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>If you are a new inspector, please include an estimate for next 12 months.</span>
              </p>
              <p v-if="getApplicantType === 'RWS'" class="more-desc-p table-p flex">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span><strong>Commercial Property</strong> means any building greater than a 4 family dwelling. <u>IMPORTANT: RWS’s primary policy does NOT cover all Commercial Property Inspections.</u> Please email a description of commercial properties you inspect to  RWS info@rwsinsurance.com, 866-530-0531 to ensure you’re covered properly.</span>
              </p>
              <p v-else-if="getApplicantType === 'RISKPRO'" class="more-desc-p table-p flex">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span><strong>Commercial Property</strong> means any building greater than a 4 family dwelling. <u>IMPORTANT: RISKPRO’s primary policy does NOT cover all Commercial Property Inspections.</u> Please email a description of commercial properties you inspect to RISKPRO@liabilityinsuranceapps.com, 972-235-3030 to ensure you’re covered properly.</span>
              </p>

              <p v-else class="more-desc-p table-p flex">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span><strong>Commercial Property</strong> means any building greater than a 4 family dwelling. <u>IMPORTANT: OREP’s primary policy does NOT cover all Commercial Property Inspections.</u> Please email a description of commercial properties you inspect to inspectors@orep.org to ensure you’re covered properly.</span>
              </p>

            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">7.</span>Have you experienced a bankruptcy in the last seven years?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveYourExperiencedBankruptcyInLast7Years"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.haveYourExperiencedBankruptcyInLast7Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveYourExperiencedBankruptcyInLast7Years"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.haveYourExperiencedBankruptcyInLast7Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('haveYourExperiencedBankruptcyInLast7Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveYourExperiencedBankruptcyInLast7Years') | filterText }}</span>
                </div>
              </div>
              <p
                  class="form-p"
                  v-if="quote.haveYourExperiencedBankruptcyInLast7Years === 'true' || quote.haveYourExperiencedBankruptcyInLast7Years == true"
                >If yes, which type of bankruptcy? (Chapter 7, 11, 13)
              </p>
              <span v-if="quote.haveYourExperiencedBankruptcyInLast7Years === 'true' || quote.haveYourExperiencedBankruptcyInLast7Years == true">
                <label class="orep-label">Please check all that apply</label>
                <div class="radio orep-radio-wrapper">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        class="orep-radio"
                        name="bankruptcyReportMode"
                        value="chapter-7"
                        v-model="quote.bankruptcyReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Chapter 7</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="bankruptcyReportMode"
                        value="chapter-11"
                        class="orep-radio"
                        v-model="quote.bankruptcyReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Chapter 11</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="bankruptcyReportMode"
                        value="chapter-13"
                        class="orep-radio"
                        v-model="quote.bankruptcyReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Chapter 13</span>
                    </label>
                  </div>
                </div>
              </span>


            </article>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Operations</h1>
              <img
                src="../../../public/assets/images/notepad.png"
                class="title-section-img form-title-img ops-section-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">8.</span>Does any single client represent more than 25% of the Applicant's gross revenue?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="singleClientProvidesMt25PercentRevenue"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.singleClientProvidesMt25PercentRevenue"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="singleClientProvidesMt25PercentRevenue"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.singleClientProvidesMt25PercentRevenue"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('singleClientProvidesMt25PercentRevenue')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('singleClientProvidesMt25PercentRevenue') | filterText }}</span>
                </div>
              </div>
              <input
                type="text"
                class="orep-text-input js-orep-input"
                placeholder="Please provide details:"
                v-if="quote.singleClientProvidesMt25PercentRevenue === 'true' || quote.singleClientProvidesMt25PercentRevenue == true"
                name="singleClientProvidesMt25PercentDetails"
                v-model="quote.singleClientProvidesMt25PercentDetails"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">9.</span>Do you do Compliance Inspections for building codes and ordinances, zoning regulations or contract specifications?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="complianceInspections"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.complianceInspections"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="complianceInspections"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.complianceInspections"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('complianceInspections')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('complianceInspections') | filterText }}</span>
                </div>
              </div>
              <input
                type="text"
                class="orep-text-input js-orep-input"
                placeholder="Please provide details:"
                v-if="quote.complianceInspections === 'true' || quote.complianceInspections == true"
                name="complianceInspectionsDetails"
                v-model="quote.complianceInspectionsDetails"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">10.</span>Is the Applicant the exclusive inspector for any real estate agency, developer, and/or builder?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="applicantExclusiveToAnyCompany"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.applicantExclusiveToAnyCompany"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantExclusiveToAnyCompany"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.applicantExclusiveToAnyCompany"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantExclusiveToAnyCompany')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantExclusiveToAnyCompany') | filterText }}</span>
                </div>
              </div>
              <input
                type="text"
                class="orep-text-input js-orep-input"
                placeholder="Please provide details:"
                v-if="quote.applicantExclusiveToAnyCompany === 'true' || quote.applicantExclusiveToAnyCompany == true"
                name="exclusiveInspectorDetails"
                v-model="quote.exclusiveInspectorDetails"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">11.</span>Are you involved in the auction of personal property?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="involvedInAuctionOfPersonalProperty"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.involvedInAuctionOfPersonalProperty"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="involvedInAuctionOfPersonalProperty"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.involvedInAuctionOfPersonalProperty"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('involvedInAuctionOfPersonalProperty')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('involvedInAuctionOfPersonalProperty') | filterText }}</span>
                </div>
              </div>
              <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please provide details:"
                  v-if="quote.involvedInAuctionOfPersonalProperty === 'true' || quote.involvedInAuctionOfPersonalProperty == true"
                  name="auctionsPersonalProperty"
                  v-model="quote.auctionsPersonalProperty"
                >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                  <span class="qtn mrpx-5">12.</span>Do you provide architectural, environmental consulting/remediation, radon/pollutant mitigation or appraising? (Please Answer “No” if you simply test for Mold and/or Radon)
                </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="providesOtherServices"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.providesOtherServices"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="providesOtherServices"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.providesOtherServices"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('providesOtherServices')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('providesOtherServices') | filterText }}</span>
                </div>
              </div>
              <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please provide details:"
                  v-if="quote.providesOtherServices === 'true' || quote.providesOtherServices == true"
                  name="otherServicesDetails"
                  v-model="quote.otherServicesDetails"
                >
            </article>
<!--            <article class="input-section form-section">-->
<!--              <div class="flex">-->
<!--                <div class="col-md-9">-->
<!--                  <label for class="orep-label">-->
<!--                    <span class="qtn mrpx-5">14.</span>Does applicant or any business partner, officer, owner, director, franchise company or employee operate as Builder, contractor, repair company remodeling company or sell materials or furnish any type of product or service other than inspection-related services (excluding 90-day home warranties)?-->
<!--                  </label>-->
<!--                </div>-->
<!--                <div class="col-md-3 d-flex flex-column">-->
<!--                  <div class="d-flex flex-row">-->
<!--                    <div class="radio orep-radio-wrapper">-->
<!--                  <label>-->
<!--                    <input-->
<!--                      type="radio"-->
<!--                      name="applicantOrAssociateProvidesOtherServices"-->
<!--                      value="true"-->
<!--                      class="orep-radio"-->
<!--                      v-validate="'required'"-->
<!--                      @change="validateBeforeSubmit()"-->
<!--                      v-model="quote.applicantOrAssociateProvidesOtherServices"-->
<!--                    >-->
<!--                    <span class="radio-span">Yes</span>-->
<!--                  </label>-->
<!--                </div>-->
<!--                    <div class="radio orep-radio-wrapper">-->
<!--                      <label>-->
<!--                        <input-->
<!--                          type="radio"-->
<!--                          name="applicantOrAssociateProvidesOtherServices"-->
<!--                          value="false"-->
<!--                          class="orep-radio"-->
<!--                          @change="validateBeforeSubmit()"-->
<!--                          v-model="quote.applicantOrAssociateProvidesOtherServices"-->
<!--                        >-->
<!--                        <span class="radio-span">No</span>-->
<!--                      </label>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <span-->
<!--                    v-show="errors.has('applicantOrAssociateProvidesOtherServices')"-->
<!--                    class="help is-danger form-errors text-danger"-->
<!--                  >{{ errors.first('applicantOrAssociateProvidesOtherServices') | filterText }}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <input-->
<!--                type="text"-->
<!--                class="orep-text-input js-orep-input"-->
<!--                placeholder="Please provide details:"-->
<!--                v-if="quote.applicantOrAssociateProvidesOtherServices === 'true' || quote.applicantOrAssociateProvidesOtherServices == true"-->
<!--                name="applicantOrAssociateProvidesOtherServicesDetails"-->
<!--                v-model="quote.applicantOrAssociateProvidesOtherServicesDetails"-->
<!--              >-->
<!--            </article>-->
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">13.</span>Have you or your partners, officers, owners, principals, directors, franchise company, employees entered into any hold harmless agreements (excluding limit of liability clause in contract)?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="enteredLimitedLiabilityContract"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.enteredLimitedLiabilityContract"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="enteredLimitedLiabilityContract"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.enteredLimitedLiabilityContract"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('enteredLimitedLiabilityContract')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('enteredLimitedLiabilityContract') | filterText }}</span>
                </div>
              </div>
              <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please provide details:"
                  v-if="quote.enteredLimitedLiabilityContract === 'true' || quote.enteredLimitedLiabilityContract == true"
                  name="enteredLimitedLiabilityContractDetails"
                  v-model="quote.enteredLimitedLiabilityContractDetails"
                >
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">14.</span>Do you perform inspections on property you own and/or have an interest in (including as a real estate agent/broker)?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="performInspectionsOnOwnProperty"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.performInspectionsOnOwnProperty"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="performInspectionsOnOwnProperty"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.performInspectionsOnOwnProperty"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('performInspectionsOnOwnProperty')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('performInspectionsOnOwnProperty') | filterText }}</span>
                </div>
              </div>
              <p
                  class="form-p"
                  v-if="quote.performInspectionsOnOwnProperty === 'true' || quote.performInspectionsOnOwnProperty == true"
                >Please explain (you may not qualify for coverage):</p>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  v-if="quote.performInspectionsOnOwnProperty === 'true' || quote.performInspectionsOnOwnProperty == true"
                  name="performInspectionsDetailsOnOwnProperty"
                  v-model="quote.performInspectionsDetailsOnOwnProperty"
                >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">15.</span>Do you perform repair/remodel work or building services on properties you inspect?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="providesRepairWorkOnInspectedProperty"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.providesRepairWorkOnInspectedProperty"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="providesRepairWorkOnInspectedProperty"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.providesRepairWorkOnInspectedProperty"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('providesRepairWorkOnInspectedProperty')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('providesRepairWorkOnInspectedProperty') | filterText }}</span>
                </div>
              </div>
              <p
                  class="form-p"
                  v-if="quote.providesRepairWorkOnInspectedProperty === 'true' || quote.providesRepairWorkOnInspectedProperty == true"
                >Please explain (you may not qualify for coverage):</p>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  v-if="quote.providesRepairWorkOnInspectedProperty === 'true' || quote.providesRepairWorkOnInspectedProperty == true"
                  name="providesRepairWorkOnInspectedPropertyDetails"
                  v-model="quote.providesRepairWorkOnInspectedPropertyDetails"
                >
            </article>
            <article class="input-section form-section no-bottom-border">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">16.</span>Does the Applicant or any firm member hold other professional licenses or operate as Builder, contractor, repair company, remodeling company or sell materials or furnish any type of product or service other than inspection-related services (excluding 90-day home warranties)?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="applicantOrAssociateHasAnyOtherProfessionalLicense"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.applicantOrAssociateHasAnyOtherProfessionalLicense"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantOrAssociateHasAnyOtherProfessionalLicense"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.applicantOrAssociateHasAnyOtherProfessionalLicense"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantOrAssociateHasAnyOtherProfessionalLicense')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantOrAssociateHasAnyOtherProfessionalLicense') | filterText }}</span>
                </div>
              </div>
              <span v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' || quote.applicantOrAssociateHasAnyOtherProfessionalLicense == true">
                <label class="orep-label">Please check all that apply</label>
                <div class="radio orep-radio-wrapper">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        class="orep-radio"
                        name="applicantOrAssociateReportMode"
                        value="real estate agent"
                        v-model="quote.applicantOrAssociateReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Real Estate Agent/Broker</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="applicantOrAssociateReportMode"
                        value="contractor"
                        class="orep-radio"
                        v-model="quote.applicantOrAssociateReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Contractor or Handyman</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="applicantOrAssociateReportMode"
                        value="engineer"
                        class="orep-radio"
                        v-model="quote.applicantOrAssociateReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Engineer</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="applicantOrAssociateReportMode"
                        value="pest inspector"
                        class="orep-radio"
                        v-model="quote.applicantOrAssociateReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Pest Inspector/Applicator</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="applicantOrAssociateReportMode"
                        value="other"
                        class="orep-radio"
                        v-model="quote.applicantOrAssociateReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Other</span>
                    </label>
                  </div>
              <input
                type="text"
                class="orep-text-input"
                name="otherProfessionalLicense1"
                placeholder="Please list:"
                v-if="quote.applicantOrAssociateReportMode.includes('other')"
                v-model="quote.otherProfessionalLicense1"
              >
                </div>

              </span>
            </article>
            <p class="bottom-text flex">
              <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
              <span><b>Please Note:</b> The coverage provided under this policy is for Home Inspection Services ONLY. There is no coverage for real estate sales, property management, contractors, engineering, pest application, repairs, remediation or any work/service been provided under any other business operation or professional license.</span>
            </p>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button class="pagination-dots" @click="next('home-inspector-2')" :disabled="!state.pageOneIsValid"></button>
              <button class="pagination-dots" @click="next('home-inspector-3')" :disabled="!state.pageOneIsValid || !state.pageTwoIsValid"></button>
              <button class="pagination-dots" @click="next('home-inspector-4')" :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid"></button>
              <button class="pagination-dots" @click="next('home-inspector-5')" :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="next('home-inspector-6')" :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid"></button>
              <button class="pagination-dots" :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid" @click="next('home-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('home-inspector-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import {APP_STATUS, STATES, STATUS, YEARS} from '../../utils/constants';

export default {
  name: 'home-inspector-1',
  data() {
    return {
      states: STATES,
      years: YEARS,
    };
  },
  computed: {
    quote() {
      return this.$store.state.homeInspector.quote;
    },
    state() {
      return this.$store.state.homeInspector;
    },
    errorMsg() {
      return this.$store.state.homeInspector.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/home-inspector-ibd/' || first === '/portal/home-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
        return 'IBD';
      }else if (first === '/portal/home-inspector-rws/' || first === '/portal/home-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
        return 'RWS';
      }else if (first === '/portal/home-inspector-spmga/' || first === '/portal/home-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
        return 'SPMGA';
      }
      else if (first === '/portal/home-inspector-new/' || first === '/portal/home-inspector-NEW/'|| this.quote.customer.partnerName === 'NEW'){
        return 'NEW';
      }
      else if (first === '/riskpro/home-inspector/' || first === '/RISKPRO/home-inspector/' ||this.quote.customer.partnerName === 'RISKPRO'){
        return 'RISKPRO';
      }
      else {
        return 'OREP';
      }
    },
    revenueFromResidentialInspectionsInThisYear: {
      get() {
        return this.quote.revenueFromResidentialInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.revenueFromResidentialInspectionsInThisYear = val;
      },
    },
    numberOfResidentialInspectionsInThisYear: {
      get() {
        return this.quote.numberOfResidentialInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.numberOfResidentialInspectionsInThisYear = val;
      },
    },
    revenueFromResidentialInspectionsExpectedInNextYear: {
      get() {
        return this.quote.revenueFromResidentialInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.revenueFromResidentialInspectionsExpectedInNextYear = val;
      },
    },
    numberOfResidentialInspectionsExpectedInNextYear: {
      get() {
        return this.quote.numberOfResidentialInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.numberOfResidentialInspectionsExpectedInNextYear = val;
      },
    },
    revenueFromResidentialOverInspectionsInThisYear: {
      get() {
        return this.quote.revenueFromResidentialOverInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.revenueFromResidentialOverInspectionsInThisYear = val;
      },
    },
    numberOfResidentialOverInspectionsInThisYear: {
      get() {
        return this.quote.numberOfResidentialOverInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.numberOfResidentialOverInspectionsInThisYear = val;
      },
    },
    revenueFromResidentialOverInspectionsExpectedInNextYear: {
      get() {
        return this.quote.revenueFromResidentialOverInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.revenueFromResidentialOverInspectionsExpectedInNextYear = val;
      },
    },
    numberOfResidentialOverInspectionsExpectedInNextYear: {
      get() {
        return this.quote.numberOfResidentialOverInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.numberOfResidentialOverInspectionsExpectedInNextYear = val;
      },
    },
    revenueFromCommercialInspectionsInThisYear: {
      get() {
        return this.quote.revenueFromCommercialInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.revenueFromCommercialInspectionsInThisYear = val;
      },
    },
    numberOfCommercialInspectionsInThisYear: {
      get() {
        return this.quote.numberOfCommercialInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.numberOfCommercialInspectionsInThisYear = val;
      },
    },
    revenueFromCommercialInspectionsExpectedInNextYear: {
      get() {
        return this.quote.revenueFromCommercialInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.revenueFromCommercialInspectionsExpectedInNextYear = val;
      },
    },
    numberOfCommercialInspectionsExpectedInNextYear: {
      get() {
        return this.quote.numberOfCommercialInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.numberOfCommercialInspectionsExpectedInNextYear = val;
      },
    },
    revenueFromOtherInspectionsInThisYear: {
      get() {
        return this.quote.revenueFromOtherInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.revenueFromOtherInspectionsInThisYear = val;
      },
    },
    numberOfOtherInspectionsInThisYear: {
      get() {
        return this.quote.numberOfOtherInspectionsInThisYear || '';
      },
      set(val) {
        this.quote.numberOfOtherInspectionsInThisYear = val;
      },
    },
    revenueFromOtherInspectionsExpectedInNextYear: {
      get() {
        return this.quote.revenueFromOtherInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.revenueFromOtherInspectionsExpectedInNextYear = val;
      },
    },
    numberOfOtherInspectionsExpectedInNextYear: {
      get() {
        return this.quote.numberOfOtherInspectionsExpectedInNextYear || '';
      },
      set(val) {
        this.quote.numberOfOtherInspectionsExpectedInNextYear = val;
      },
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg,
          });
        }
      },
    },
  },

  methods: {
    next(routeName) {
      this.$router.push({
        name: routeName,
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.quote.status = STATUS.Submitted;
      this.quote.customer.contactName = this.state.quote.nameOfPrincipalHomeInspector;
      this.quote.customer.companyName = this.state.quote.fullLegalNameOfApplicant;
      this.quote.customer.isHomeInspector = 'True';
      this.quote.signedInUser = this.state.quote.signedInUser;
      this.quote.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'IBD'){
        this.quote.customer.partnerName = 'IBD';
      }else if (this.getApplicantType === 'SPMGA') {
        this.quote.customer.partnerName = 'SPMGA';
      } else if (this.getApplicantType === 'RWS') {
        this.quote.customer.partnerName = 'RWS';
      } else if (this.getApplicantType === 'RISKPRO') {
        this.quote.customer.partnerName = 'RISKPRO';
      } else if (this.getApplicantType === 'NEW') {
        this.quote.customer.partnerName = 'NEW';
      }
      else {
        this.quote.customer.partnerName = '';
      }
        this.$store.dispatch('homeInspector/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    checkServices(service) {
      return this.quote.applicantOrAssociateReportMode.includes(service);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf('req') !== -1) {
          return 'This field is required';
        }
        return x.replace('_', ' ');
      }
    },
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.quote.applicantRequestFrom = params.filter;
    }

    const self = this;
    function numberQtns(startNumber) {
      const numberOfQtns = document.querySelectorAll('.qtn');
      let i;

      for (i = 0; i < numberOfQtns.length; i++) {
        numberOfQtns[i].innerHTML = `${startNumber}.`;
        startNumber++;
      }
    }

    function validateInputs() {
      const inputFields = $('.js-orep-input');
      let i;

      for (i = 0; i < inputFields.length; i++) {
        if (
          inputFields.eq(i).val() === ''
          || inputFields.eq(i).val() === null
        ) {
          if (
            inputFields
              .eq(i)
              .parent()
              .find('.js-input-errors').length == 0
          ) {
            inputFields
              .eq(i)
              .parent()
              .append(
                "<span class='js-input-errors text-danger'>This field is required</span>",
              );
          } else {
            inputFields
              .eq(i)
              .parent()
              .find('.js-input-errors')
              .show();
          }
        } else {
          inputFields
            .eq(i)
            .parent()
            .find('.js-input-errors')
            .hide();
        }
      }
    }

    function setOnChange() {
      let i;
      const inputFields = $('.js-orep-input');

      for (i = 0; i < inputFields.length; i++) {
        inputFields.eq(i).change(() => {
          validateInputs();
        });
      }
    }

    $('html, body').animate({
      scrollTop: $('.orep-header').offset().top,
    }, 500);
    // numberQtns(1);
    // setOnChange();
  },

  components: {},
};
</script>
